import { getOperadores, createOperador, updateOperador, deleteOperador } from '../models/operadorModel.js';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase';
import { toasts } from "svelte-toasts";

export async function fetchOperadores(page, perPage) {
  try {
    const response = await getOperadores(page, perPage);
    return {
      operador: response.items,
      totalRecords: response.totalItems,
      currentPage: response.page,
    };
  } catch (error) {
    console.error("Error fetching operadores:", error);
    Swal.fire('Error', 'No se pudieron cargar los operadores', 'error');
    return null;
  }
}

export async function saveOperador(operador, currentOperadorId) {
  try {
    if (currentOperadorId) {
      await updateOperador(currentOperadorId, operador);
      toasts.add({
        title: 'Éxito',
        description: 'Operador guardado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true,
      });
    } else {
      await createOperador(operador);
      toasts.add({
        title: 'Éxito',
        description: 'Operador creado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true,
      });
    }
  } catch (error) {
    console.error("Error saving operador:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar el operador',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
  }
}

export async function removeOperador(id) {
  try {
    await deleteOperador(id);
    toasts.add({
      title: 'Éxito',
      description: 'Operador eliminado exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
  } catch (error) {
    console.error("Error deleting operador:", error);
    Swal.fire('Error', 'No se pudo eliminar el operador', 'error');
  }
}

// Suscripción en tiempo real a cambios en la colección 'operador'
export function subscribeToOperadores(searchQuery, handleSearch) {
  pb.collection('operador').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    await handleSearch(1); // Actualiza la lista con la primera página
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromOperadores() {
  pb.collection('operador').unsubscribe('*');
}

export async function searchOperadores(query, page = 1, perPage = 10) {
  try {
    const response = await pb.collection('operador').getList(page, perPage, {
      filter: `nombre ~ "${query}"`, // Búsqueda por el campo 'nombre'
    });
    return {
      operador: response.items,
      totalRecords: response.totalItems,
      currentPage: response.currentPage,
    };
  } catch (error) {
    console.error("Error searching operadores:", error);
    Swal.fire('Error', 'No se pudieron buscar los operadores', 'error');
    return null;
  }
}
